import { CompanyRole } from 'constants/CompanyRole';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'store';
import { profileSelector } from 'store/selectors/profile-selectors';

interface RequireRoleProps {
  roles: CompanyRole[];
  children: JSX.Element;
  redirectTo?: string;
}

const RequireRole = (props: RequireRoleProps): JSX.Element => {
  const { roles, children, redirectTo } = props;
  const user = useAppSelector(profileSelector);

  if (!user) {
    return null;
  }

  if (!roles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

RequireRole.defaultProps = {
  redirectTo: '/dashboard',
};

export default RequireRole;
